window.OrderModal = class OrderModal {
  constructor() {
    this.orderStatusModal = document.getElementById("order_status_modal");
    this.processingState = document.getElementById("processing_state");
    this.errorState = document.getElementById("error_state");
    this.statusState = document.getElementById("status_state");
    this.reviewState = document.getElementById("review_state");
    this.processingText = document.getElementById("processing_text");
    this.errorText = document.getElementById("error_text");
    this.orderStatusTotal = document.getElementById("order_status_total");
    this.exitButton = document.getElementById("exit_button");
    this.closeErrorButton = document.getElementById("close_error_button");
    this.closeReviewButton = document.getElementById("close_review_button");

    this.exitButton?.addEventListener("click", () => {
      window.location.href = "/";
    });
    this.closeErrorButton?.addEventListener("click", () => this._closeModal());
    this.closeReviewButton?.addEventListener("click", () => {
      this._closeModal();
      this._onReviewClose?.();
    });
  }

  showProcessing() {
    this._resetModalStates();
    if (this.processingText) this.processingText.textContent = "جاري المعالجة...";
    if (this.processingState) this.processingState.classList.remove("hidden");
    this._openModal();
  }

  showRedirecting() {
    this._resetModalStates();
    if (this.processingText) {
      this.processingText.textContent = "يرجى الانتظار ... سيتم تحويلك الى الصفحة الامنة لادخال معلومات الدفع";
    }
    if (this.processingState) this.processingState.classList.remove("hidden");
    this._openModal();
  }

  showItemsNeedReview(onClose) {
    this._onReviewClose = onClose;
    this._resetModalStates();
    if (this.reviewState) this.reviewState.classList.remove("hidden");
    this._openModal();
  }

  showError(message) {
    this._resetModalStates();
    if (message && this.errorText) {
      this.errorText.textContent = message;
    }
    if (this.errorState) this.errorState.classList.remove("hidden");
    this._openModal();
  }

  showSuccess(totalCost) {
    this._resetModalStates();
    if (this.orderStatusTotal) {
      this.orderStatusTotal.textContent = this._formatToDinar(totalCost);
    }
    if (this.statusState) this.statusState.classList.remove("hidden");
    this._openModal();

    setTimeout(() => {
      this.exitButton?.classList.remove("hidden-but-exist");
    }, 2200);
  }

  _resetModalStates() {
    this.processingState?.classList.add("hidden");
    this.errorState?.classList.add("hidden");
    this.statusState?.classList.add("hidden");
    this.reviewState?.classList.add("hidden");
    this.exitButton?.classList.add("hidden-but-exist");
  }

  _openModal() {
    this.orderStatusModal?.classList.add("opened-orderStatusModal");
    document.body.classList.add("modal-opened");
  }

  _closeModal() {
    this.orderStatusModal?.classList.remove("opened-orderStatusModal");
    document.body.classList.remove("modal-opened");
  }

  _formatToDinar(value) {
    const n = parseFloat(value) || 0;
    return `${n.toFixed(2)} دينار`;
  }
};
